export const projectsOptions = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "1rem",
  padding: "10px",
  width: "100%",
};

export const projectsChip = {
  borderRadius: "5px",
};
